import Article1 from './assets/article1.png'
import Article2 from './assets/article2.png'
import Article3 from './assets/article3.png'
import Article2Section1 from './assets/article2-1.png'
import Article2Section2 from './assets/article2-2.png'


export const articlesData = [
    {
      "id": 1,
      "displayImage": Article1,
      "author": "Betty Hanson",
      "date": "October 20, 2024",
      "category": "Legal Advice",
      "title": "Top Tips for Strong Contracts",
      "introduction": "Learn the key elements every legal contract should include to ensure protection and clarity.",
      "sections": [
        {
        "image": "/path/to/sectionImage1.jpg",
          "paragraph": "In today’s competitive business environment, companies must navigate complex legal issues, including defending against unfair dismissal claims. This case study explores how a mid-sized company successfully defended itself in such a case, preserving both its legal standing and its reputation while minimizing financial damages."
        },
        {
          
          "paragraph":  "Introduction:   In today’s competitive business environment, companies must navigate complex legal issues, including defending against unfair dismissal claims. This case study explores how a mid-sized company successfully defended itself in such a case, preserving both its legal standing and its reputation while minimizing financial damages.    The company in question was faced with a former employee filing an unfair dismissal claim, asserting that their termination was not only unjustified but also discriminatory in nature. This employee had been with the organization for over five years, building a solid record of contributions during that time. However, as internal dynamics evolved, issues began to surface regarding their performance and their relationships with colleagues. Despite being provided with warnings and opportunities for improvement, these concerns were never fully resolved, and tensions continued to escalate. These performance issues, coupled with growing internal conflicts, ultimately led to the company's decision to terminate the employee.   Upon their dismissal, the former employee contested the company’s actions, arguing that the termination was not only abrupt but grounded in unfair practices. They claimed that their dismissal was driven by discrimination rather than legitimate performance concerns. In response to the termination, they filed a formal claim seeking compensation and damages, alleging wrongful termination, discrimination, and emotional distress. The employee's legal case further cited specific instances where they believed they were treated differently from their peers, highlighting what they saw as discriminatory practices embedded within the company culture."


          
          
          
        },
        {
          "image": "/path/to/sectionImage2.jpg",
          "paragraph": "Second section paragraph goes here, with more detailed insights on protective clauses."
        },
        {
          "paragraph": "Final section paragraph here, wrapping up the discussion on legal safety in contracts."
        }
      ]
    },
    {
        "id": 2,
        "displayImage": Article2,
        "author": "Robert Fox",
        "date": "August 14, 2024",
        "category": "Case Studies",
        "title": "Defending Against Unfair Dismissal Claims",
        "introduction": "This case shows how a company defended itself against an unfair dismissal claim, resulting in a favorable outcome.",
        "sections": [
          {
            "paragraph": "First section paragraph goes here, detailing specific aspects of contract law."
          },
          {
            "paragraph": "Challenges:   The company had to prove that the dismissal was lawful, fair, and followed due process. Additionally, the company needed to ensure that its internal communication and HR practices were compliant with employment law, Additionally, the company needed to ensure that its internal communication and HR practices were compliant with employment law, demonstrating that the decision to terminate the employee was not influenced by any discriminatory factors.   Key challenges included: Collecting sufficient documentation of the employee’s performance issues. Ensuring that HR procedures were properly followed. Protecting the company’s reputation throughout the legal proceedings."
          },
          {
            "paragraph": "Final section paragraph here, wrapping up the discussion on legal safety in contracts."
          }
        ]
      },
      {
        "id": 3,
        "displayImage": Article3,
        "author": "James Martell",
        "date": "September 18, 2024",
        "category": "Industry Updates",
        "title": "Trends in Corporate Mergers & Acquisitions",
        "introduction": "Explore the latest trends in corporate mergers and acquisitions, and what legal teams need to understand.",
        "sections": [
          {
            "image": "/path/to/sectionImage1.jpg",
            "paragraph": "First section paragraph goes here, detailing specific aspects of contract law."
          },
          {
            "image": "/path/to/sectionImage2.jpg",
            "paragraph": "Second section paragraph goes here, with more detailed insights on protective clauses."
          },
          {
            "paragraph": "Final section paragraph here, wrapping up the discussion on legal safety in contracts."
          }
        ]
      },
    // Add more articles as needed
  ]
  